"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../form-constants");
var form_input_element_base_1 = require("./form-input-element-base");
/** [[PostalCodeElement]] with the default values set for the props */
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.postalCode, country: form_constants_1.countryCodes.UnitedStates });
/** Create immutable record for the postal code element, setting default values at start */
exports.PostalCodeElementRecord = immutable_1.Record(exports.defaultValues);
/** Used to handle country-specific postal codes. Immutable Record of [[PostalCodeElement]] with default props */
var ImmutablePostalCodeElement = /** @class */ (function (_super) {
    __extends(ImmutablePostalCodeElement, _super);
    function ImmutablePostalCodeElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutablePostalCodeElement;
}(exports.PostalCodeElementRecord));
exports.ImmutablePostalCodeElement = ImmutablePostalCodeElement;
//# sourceMappingURL=postal-code-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/postal-code-element.js
// module id = 1144
// module chunks = 0